import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getAllocatedImsis = async (token, options = {}) => {
    log("welcome in getAllocatedImsis")

    if (!token || token === "") {
        alert("No token in getAllocatedImsis")
        return {error: true, message: "No token provided", imsis: [], total: 0}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_allocated_imsis_api'
        log("url=" + url)

        // Build query params
        const params = {}

        // Status filters
        if (options.status_all) {
            params.status_all = true
        } else if (options.statuses && options.statuses.length > 0) {
            if (options.statuses.includes('active')) params.status_active = true
            if (options.statuses.includes('suspended')) params.status_suspended = true
            if (options.statuses.includes('not_provisioned')) params.status_not_provisioned = true
            if (options.statuses.includes('terminated')) params.status_terminated = true
            if (options.statuses.includes('unallocated')) params.status_unallocated = true
        }

        if (options.search_term) {
            params.search_term = options.search_term
        }
        if (options.client_id) {
            params.client_id = options.client_id
        }
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }
        if (options.sort_by) {
            params.sort_by = options.sort_by
        }
        if (options.sort_direction) {
            params.sort_order = options.sort_direction
        }
        if (options.page) {
            params.page = options.page
        }
        if (options.per_page) {
            params.per_page = options.per_page
        }
        if (options.imsi_group_id) {
            params.imsi_group_id = options.imsi_group_id
        }
        if (options.network_id) {
            params.network_id = options.network_id
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getAllocatedImsis")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getAllocatedImsis")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getAllocatedImsis", imsis: [], total: 0}
    }
}

export const getImsiDetails = async (token, sim_id, imsi_id) => {
    log("welcome in getImsiDetails for sim_id=" + sim_id + " imsi_id=" + imsi_id)

    if (!token || token === "") {
        alert("No token in getImsiDetails")
        return {error: true, message: "No token provided", details: null}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_imsi_details_api'
        log("url=" + url)

        const params = {}
        if (sim_id) params.sim_id = sim_id
        if (imsi_id) params.imsi_id = imsi_id
        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getImsiDetails")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getImsiDetails")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getImsiDetails", details: null}
    }
}

export const suspendSim = async (token, sim_id) => {
    log("welcome in suspendSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/suspend_sim_api'
        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios suspendSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in suspendSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la suspendSim"}
    }
}

export const reactivateSim = async (token, sim_id) => {
    log("welcome in reactivateSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/reactivate_sim_api'
        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios reactivateSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in reactivateSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la reactivateSim"}
    }
}

export const terminateSim = async (token, sim_id) => {
    log("welcome in terminateSim for sim_id=" + sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/terminate_sim_subscription_api'
        const result = await axios.post(url, {sim_id: sim_id}, {headers: headers})
        log("result.data din axios terminateSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in terminateSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la terminateSim"}
    }
}

export const provisionSim = async (token, sim_id, msisdn_id, imsi_id = null, mno_product = null, client_service_id = null) => {
    log("welcome in provisionSim for sim_id=" + sim_id + ", msisdn_id=" + msisdn_id + ", imsi_id=" + imsi_id + ", mno_product=" + mno_product + ", client_service_id=" + client_service_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        const payload = { sim_id: sim_id, msisdn_id: msisdn_id }
        if (imsi_id) payload.imsi_id = imsi_id
        if (mno_product) payload.mno_product = mno_product
        if (client_service_id) payload.client_service_id = client_service_id

        let url = BASE_URL + '/home/provision_sim_api'
        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios provisionSim")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in provisionSim")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la provisionSim"}
    }
}

// Get pricing options for moving IMSI to subclient
export const getImsiMoveOptions = async (token, imsiId) => {
    log("welcome in getImsiMoveOptions for imsi_id=" + imsiId)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_imsi_move_options_api'
        const params = { imsi_id: imsiId }
        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getImsiMoveOptions")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getImsiMoveOptions")
        log(err)
        error.value = err.message
        return {error: true, message: "Error getting IMSI move options"}
    }
}

export const moveImsiToSubclient = async (token, data) => {
    log("welcome in moveImsiToSubclient for sim_id=" + data.sim_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/move_imsi_to_subclient_api'
        const result = await axios.post(url, data, {headers: headers})
        log("result.data din axios moveImsiToSubclient")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in moveImsiToSubclient")
        log(err)
        error.value = err.message
        return {error: true, message: "Error moving IMSI to subclient"}
    }
}

export const reprovisionTerminatedImsi = async (token, imsi_id, msisdn_id, mno_product) => {
    log("welcome in reprovisionTerminatedImsi for imsi_id=" + imsi_id + ", msisdn_id=" + msisdn_id + ", mno_product=" + mno_product)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    if (!imsi_id) {
        return {error: true, message: "imsi_id is required"}
    }

    if (!msisdn_id) {
        return {error: true, message: "msisdn_id is required"}
    }

    if (!mno_product) {
        return {error: true, message: "mno_product is required"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        const payload = {
            imsi_id: imsi_id,
            msisdn_id: msisdn_id,
            mno_product: mno_product
        }

        let url = BASE_URL + '/home/reprovision_terminated_imsi_api'
        const result = await axios.post(url, payload, {headers: headers})
        log("result.data from reprovisionTerminatedImsi")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in reprovisionTerminatedImsi")
        log(err)
        error.value = err.message
        return {error: true, message: "Error reprovisioning terminated IMSI"}
    }
}

export const updateImsiInfo = async (token, imsi_id) => {
    log("welcome in updateImsiInfo for imsi_id=" + imsi_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_imsi_info_api'
        const result = await axios.post(url, {imsi_id: imsi_id}, {headers: headers})
        log("result.data din axios updateImsiInfo")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateImsiInfo")
        log(err)
        error.value = err.message
        return {error: true, message: "Error updating IMSI info"}
    }
}

export const getSubscriberStatus = async (token, imsi_id) => {
    log("welcome in getSubscriberStatus for imsi_id=" + imsi_id)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_subscriber_status_api'
        const result = await axios.get(url, {headers: headers, params: {imsi_id: imsi_id}})
        log("result.data din axios getSubscriberStatus")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getSubscriberStatus")
        log(err)
        error.value = err.message
        return {error: true, message: "Error getting subscriber status"}
    }
}

const useGetAllocatedImsisAPI = () => {
    return {error, getAllocatedImsis, getImsiDetails, suspendSim, reactivateSim, terminateSim, provisionSim, getImsiMoveOptions, moveImsiToSubclient, updateImsiInfo, getSubscriberStatus}
}

export default useGetAllocatedImsisAPI
